
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import ContratoData, { ContratoDataRequired } from "./ContratoData";
import { mask } from "vue-the-mask";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";
import SistemaMixin from "../../Application/mixins/SistemaMixin";
export default {
  name: "app-contrato-form",
  mixins: [validationMixin, SistemaMixin],
  directives: {
    mask,
  },
  watch: {
    contrato(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.form = newValue;
      }
    },
  },
  components: {
    Money,
  },
  data() {
    return {
      tabIndex: 0,
      form: {},
      id_empresa: null,
      url: null,
      contrato: new ContratoData({}),
      configMoney: settingMoney,
      contasReceber: [],
    };
  },
  validations: {
    form: ContratoDataRequired,
  },
  async mounted() {
    await this.getDataInit();
    if (!this.isRevenda) {
      this.$router.push({ name: "dashboard" });
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getDataInit() {
      this.setLoading(true);
      const id_empresa = this.$route.params.id_empresa;
      this.id_empresa = id_empresa;
      let { data } = await this.$http.post("contratos/find", {
        id_empresa: id_empresa,
      });
      this.setLoading(false);
      if (!data.id) {
        this.contrato = new ContratoData({});
        this.url = "/contratos/create";
        return;
      }
      this.contrato = new ContratoData(data);
      this.url = "contratos/update";
      this.contasReceber = data.contas;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    setActivePreviousTab() {
      this.tabIndex = parseInt(localStorage.getItem("builderTab")) || 0;
      const links = this.$refs["builder-tab"].querySelectorAll(".nav-link");
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }
      this.$refs["builder-tab"]
        .querySelector(`[data-tab="${this.tabIndex}"]`)
        .classList.add("active");
    },
    setActiveTab(event) {
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }
      this.tabIndex = parseInt(event.target.getAttribute("data-tab"));
      event.target.classList.add("active");
    },
    setBoleto() {
      this.form.gerar_boleto = this.form.gerar_boleto == true ? false : true;
    },
    async atualizarContrato() {
      if (this.form.id_contrato_cliente) {
        this.$swal
          .fire({
            icon: "warning",
            title:
              "Deseja atualizar o contrato, as parcelas não recebidas serão excluídas," +
              "e serão criadas novamente conforme o valor do contrato!",
            showCancelButton: true,
            confirmButtonText: `Sim`,
            cancelButtonText: `Não`,
            confirmButtonColor: "#f64e60",
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              this.setLoading(true);
              const response = await this.$http.post(this.url, this.form);
              // Se o backend retornar a lista de boletos no data
              if (response.data && Array.isArray(response.data)) {
                response.data.forEach((boleto) => {
                  if (boleto.url_boleto) {
                    window.open(boleto.url_boleto, "_blank");
                  }
                });
              }

              this.setLoading(false);
              this.$toast.success("Contrato atualizado com sucesso!");
              this.$router.push({ name: "clientesLista" });
            }
          });
      }
    },
    async onSubmit() {
      const submitButton = this.$refs["submit_contrato"];
      try {
        this.$v.form.$touch();
        if (this.$v.form.$anyError) {
          this.$toast.error(
            "Verifique todos os campos obrigatórios do formulário!"
          );
          return;
        }
        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");
        this.form.id_empresa = this.id_empresa;
        const response = await this.$http.post(this.url, this.form);
        // Se o backend retornar a lista de boletos no data
        if (response.data && Array.isArray(response.data)) {
          response.data.forEach((boleto) => {
            if (boleto.url_boleto) {
              window.open(boleto.url_boleto, "_blank");
            }
          });
        }
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        this.$toast.success("Contrato gerado com sucesso!");
        submitButton.removeAttribute("disabled", "");
        this.$router.push({ name: "clientesLista" });
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        submitButton.removeAttribute("disabled", "");
      }
    },
  },
  computed: {
    ...mapGetters(["isRevenda"]),
  },
};
